//
// Copyright (c) 2011-2024 by Curalate, Inc.
//

import { FeatureNames } from '@bvengineering/curalate-features';

import { createHasFeatureSelector } from '@redux/selectors/createHasFeatureSelector';

export const getIsInstagramCompetitorsEnabled = createHasFeatureSelector(
  FeatureNames.InstagramCompetitors,
);

export const getIsEngageEnabled = createHasFeatureSelector(FeatureNames.Engage);

export const getIsPromotedPostsAccessEnabled = createHasFeatureSelector(
  FeatureNames.PromotedPosts,
);

export const getIsShopTagsEnabled = createHasFeatureSelector(
  FeatureNames.InstagramShopTagsInsights,
);

export const getIsImageInsightsEnabled = createHasFeatureSelector(
  FeatureNames.ImageInsights,
);

export const getIsInstagramCompetitorsOldDeprecateEnabled =
  createHasFeatureSelector(FeatureNames.InstagramCompetitorsOldDeprecate);
